import * as types from './types';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const mutations = {
  [types.CLEAR_BRANCHES]: $state => {
    $state.records = [];
  },
  [types.SET_BRANCHES]: ($state, data) => {
    $state.records = data;
  },
  [types.ADD_BRANCH]: ($state, data) => {
    $state.records.push(data);
  },
  [types.EDIT_BRANCH]: ($state, data) => {
    $state.records = $state.records.map(record =>
      record.id === data.id ? data : record
    );
  },
  [types.DELETE_BRANCH]: ($state, branchId) => {
    $state.records = $state.records.filter(record => record.id !== branchId);
  },
  SET_UI_FLAG($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
};
